// extracted by mini-css-extract-plugin
module.exports = {"container":"OTPModal_container__2adVF","inputDiv":"OTPModal_inputDiv__3lYxT"};